
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Table
} from "reactstrap";
const FormMotivoAusencias = (props) => {
  return (
    <Modal isOpen={props.modalOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Añadir Nuevo Motivo de Ausencia</ModalHeader>
      <ModalBody>
        <Form onSubmit={props.handleCreateMotivo}>
          <FormGroup>
            <Label for="descripcion">Descripción</Label>
            <Input
              type="text"
              id="descripcion"
              value={props.newDescripcion}
              onChange={(e) => props.setNewDescripcion(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="diasPermitido">Días de ausencia permitidos</Label>
            <Input
              type="number"
              id="diasPermitido"
              value={props.diasPermitidos}
              onChange={(e) => props.setDiasPermitidos(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="tipoComputoDias">Tipo de cómputo</Label>
            <Input
              type="select"
              id="tipoComputoDias"
              value={props.tipoComputoDias || "HABILES"}
              onChange={(e) => props.setTipoComputoDias(e.target.value)}
            >
              <option value="HABILES">Habiles</option>
              <option value="NATURALES">Naturales</option>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={props.handleCreateMotivo}>Guardar</Button>
        <Button color="danger" onClick={props.toggleModal}>Cancelar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default FormMotivoAusencias;
